/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * Bondsmith Savings Exchange Operation Portal APIs
 * OpenAPI spec version: 0.1
 */
import { useMutation } from 'react-query';
import type {
  MutationFunction,
  UseMutationOptions,
  UseMutationResult,
} from 'react-query';
import { customInstance } from '../../../../mutator/instance';
import type { ConnectorType } from '../../models';

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

export const changeBankClearingConnector = (
  bankUid: string,
  connectorType: ConnectorType
) => {
  return customInstance<void>({
    url: `/operations/entity-internal-account/migrate/banks/${bankUid}/connector/${connectorType}`,
    method: 'PUT',
  });
};

export const getChangeBankClearingConnectorMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof changeBankClearingConnector>>,
    TError,
    { bankUid: string; connectorType: ConnectorType },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof changeBankClearingConnector>>,
  TError,
  { bankUid: string; connectorType: ConnectorType },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof changeBankClearingConnector>>,
    { bankUid: string; connectorType: ConnectorType }
  > = (props) => {
    const { bankUid, connectorType } = props ?? {};

    return changeBankClearingConnector(bankUid, connectorType);
  };

  return { mutationFn, ...mutationOptions };
};

export type ChangeBankClearingConnectorMutationResult = NonNullable<
  Awaited<ReturnType<typeof changeBankClearingConnector>>
>;

export type ChangeBankClearingConnectorMutationError = unknown;

export const useChangeBankClearingConnector = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof changeBankClearingConnector>>,
    TError,
    { bankUid: string; connectorType: ConnectorType },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof changeBankClearingConnector>>,
  TError,
  { bankUid: string; connectorType: ConnectorType },
  TContext
> => {
  const mutationOptions =
    getChangeBankClearingConnectorMutationOptions(options);

  return useMutation(mutationOptions);
};
export const migrateBankPaymentDues = (bankUid: string) => {
  return customInstance<void>({
    url: `/operations/entity-internal-account/migrate/banks/${bankUid}/paymentDues`,
    method: 'PUT',
  });
};

export const getMigrateBankPaymentDuesMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof migrateBankPaymentDues>>,
    TError,
    { bankUid: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof migrateBankPaymentDues>>,
  TError,
  { bankUid: string },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof migrateBankPaymentDues>>,
    { bankUid: string }
  > = (props) => {
    const { bankUid } = props ?? {};

    return migrateBankPaymentDues(bankUid);
  };

  return { mutationFn, ...mutationOptions };
};

export type MigrateBankPaymentDuesMutationResult = NonNullable<
  Awaited<ReturnType<typeof migrateBankPaymentDues>>
>;

export type MigrateBankPaymentDuesMutationError = unknown;

export const useMigrateBankPaymentDues = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof migrateBankPaymentDues>>,
    TError,
    { bankUid: string },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof migrateBankPaymentDues>>,
  TError,
  { bankUid: string },
  TContext
> => {
  const mutationOptions = getMigrateBankPaymentDuesMutationOptions(options);

  return useMutation(mutationOptions);
};
export const transferBankVirtualAccountFunds = (bankUid: string) => {
  return customInstance<void>({
    url: `/operations/entity-internal-account/migrate/banks/${bankUid}/transferFunds`,
    method: 'POST',
  });
};

export const getTransferBankVirtualAccountFundsMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof transferBankVirtualAccountFunds>>,
    TError,
    { bankUid: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof transferBankVirtualAccountFunds>>,
  TError,
  { bankUid: string },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof transferBankVirtualAccountFunds>>,
    { bankUid: string }
  > = (props) => {
    const { bankUid } = props ?? {};

    return transferBankVirtualAccountFunds(bankUid);
  };

  return { mutationFn, ...mutationOptions };
};

export type TransferBankVirtualAccountFundsMutationResult = NonNullable<
  Awaited<ReturnType<typeof transferBankVirtualAccountFunds>>
>;

export type TransferBankVirtualAccountFundsMutationError = unknown;

export const useTransferBankVirtualAccountFunds = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof transferBankVirtualAccountFunds>>,
    TError,
    { bankUid: string },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof transferBankVirtualAccountFunds>>,
  TError,
  { bankUid: string },
  TContext
> => {
  const mutationOptions =
    getTransferBankVirtualAccountFundsMutationOptions(options);

  return useMutation(mutationOptions);
};
export const createBankVirtualAccount = (
  bankUid: string,
  connectorType: ConnectorType
) => {
  return customInstance<void>({
    url: `/operations/entity-internal-account/migrate/banks/${bankUid}/${connectorType}`,
    method: 'POST',
  });
};

export const getCreateBankVirtualAccountMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createBankVirtualAccount>>,
    TError,
    { bankUid: string; connectorType: ConnectorType },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createBankVirtualAccount>>,
  TError,
  { bankUid: string; connectorType: ConnectorType },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createBankVirtualAccount>>,
    { bankUid: string; connectorType: ConnectorType }
  > = (props) => {
    const { bankUid, connectorType } = props ?? {};

    return createBankVirtualAccount(bankUid, connectorType);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateBankVirtualAccountMutationResult = NonNullable<
  Awaited<ReturnType<typeof createBankVirtualAccount>>
>;

export type CreateBankVirtualAccountMutationError = unknown;

export const useCreateBankVirtualAccount = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createBankVirtualAccount>>,
    TError,
    { bankUid: string; connectorType: ConnectorType },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof createBankVirtualAccount>>,
  TError,
  { bankUid: string; connectorType: ConnectorType },
  TContext
> => {
  const mutationOptions = getCreateBankVirtualAccountMutationOptions(options);

  return useMutation(mutationOptions);
};
export const changePlatformClearingConnector = (
  platformUid: string,
  connectorType: ConnectorType
) => {
  return customInstance<void>({
    url: `/operations/entity-internal-account/migrate/platforms/${platformUid}/connector/${connectorType}`,
    method: 'PUT',
  });
};

export const getChangePlatformClearingConnectorMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof changePlatformClearingConnector>>,
    TError,
    { platformUid: string; connectorType: ConnectorType },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof changePlatformClearingConnector>>,
  TError,
  { platformUid: string; connectorType: ConnectorType },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof changePlatformClearingConnector>>,
    { platformUid: string; connectorType: ConnectorType }
  > = (props) => {
    const { platformUid, connectorType } = props ?? {};

    return changePlatformClearingConnector(platformUid, connectorType);
  };

  return { mutationFn, ...mutationOptions };
};

export type ChangePlatformClearingConnectorMutationResult = NonNullable<
  Awaited<ReturnType<typeof changePlatformClearingConnector>>
>;

export type ChangePlatformClearingConnectorMutationError = unknown;

export const useChangePlatformClearingConnector = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof changePlatformClearingConnector>>,
    TError,
    { platformUid: string; connectorType: ConnectorType },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof changePlatformClearingConnector>>,
  TError,
  { platformUid: string; connectorType: ConnectorType },
  TContext
> => {
  const mutationOptions =
    getChangePlatformClearingConnectorMutationOptions(options);

  return useMutation(mutationOptions);
};
export const disableCustomersClearbankVirtualAccountsForPlatform = (
  platformUid: string
) => {
  return customInstance<void>({
    url: `/operations/entity-internal-account/migrate/platforms/${platformUid}/customers/clearbankVirtualAccount`,
    method: 'DELETE',
  });
};

export const getDisableCustomersClearbankVirtualAccountsForPlatformMutationOptions =
  <TError = unknown, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof disableCustomersClearbankVirtualAccountsForPlatform>
      >,
      TError,
      { platformUid: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof disableCustomersClearbankVirtualAccountsForPlatform>
    >,
    TError,
    { platformUid: string },
    TContext
  > => {
    const { mutation: mutationOptions } = options ?? {};

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof disableCustomersClearbankVirtualAccountsForPlatform>
      >,
      { platformUid: string }
    > = (props) => {
      const { platformUid } = props ?? {};

      return disableCustomersClearbankVirtualAccountsForPlatform(platformUid);
    };

    return { mutationFn, ...mutationOptions };
  };

export type DisableCustomersClearbankVirtualAccountsForPlatformMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof disableCustomersClearbankVirtualAccountsForPlatform>
    >
  >;

export type DisableCustomersClearbankVirtualAccountsForPlatformMutationError =
  unknown;

export const useDisableCustomersClearbankVirtualAccountsForPlatform = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<typeof disableCustomersClearbankVirtualAccountsForPlatform>
    >,
    TError,
    { platformUid: string },
    TContext
  >;
}): UseMutationResult<
  Awaited<
    ReturnType<typeof disableCustomersClearbankVirtualAccountsForPlatform>
  >,
  TError,
  { platformUid: string },
  TContext
> => {
  const mutationOptions =
    getDisableCustomersClearbankVirtualAccountsForPlatformMutationOptions(
      options
    );

  return useMutation(mutationOptions);
};
export const softCloseCustomersClearbankVirtualAccountsForPlatform = (
  platformUid: string
) => {
  return customInstance<void>({
    url: `/operations/entity-internal-account/migrate/platforms/${platformUid}/customers/clearbankVirtualAccount/softClose`,
    method: 'PUT',
  });
};

export const getSoftCloseCustomersClearbankVirtualAccountsForPlatformMutationOptions =
  <TError = unknown, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof softCloseCustomersClearbankVirtualAccountsForPlatform>
      >,
      TError,
      { platformUid: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof softCloseCustomersClearbankVirtualAccountsForPlatform>
    >,
    TError,
    { platformUid: string },
    TContext
  > => {
    const { mutation: mutationOptions } = options ?? {};

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof softCloseCustomersClearbankVirtualAccountsForPlatform>
      >,
      { platformUid: string }
    > = (props) => {
      const { platformUid } = props ?? {};

      return softCloseCustomersClearbankVirtualAccountsForPlatform(platformUid);
    };

    return { mutationFn, ...mutationOptions };
  };

export type SoftCloseCustomersClearbankVirtualAccountsForPlatformMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof softCloseCustomersClearbankVirtualAccountsForPlatform>
    >
  >;

export type SoftCloseCustomersClearbankVirtualAccountsForPlatformMutationError =
  unknown;

export const useSoftCloseCustomersClearbankVirtualAccountsForPlatform = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<typeof softCloseCustomersClearbankVirtualAccountsForPlatform>
    >,
    TError,
    { platformUid: string },
    TContext
  >;
}): UseMutationResult<
  Awaited<
    ReturnType<typeof softCloseCustomersClearbankVirtualAccountsForPlatform>
  >,
  TError,
  { platformUid: string },
  TContext
> => {
  const mutationOptions =
    getSoftCloseCustomersClearbankVirtualAccountsForPlatformMutationOptions(
      options
    );

  return useMutation(mutationOptions);
};
export const changePlatformCustomersClearingConnector = (
  platformUid: string,
  connectorType: ConnectorType
) => {
  return customInstance<void>({
    url: `/operations/entity-internal-account/migrate/platforms/${platformUid}/customers/connector/${connectorType}`,
    method: 'PUT',
  });
};

export const getChangePlatformCustomersClearingConnectorMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof changePlatformCustomersClearingConnector>>,
    TError,
    { platformUid: string; connectorType: ConnectorType },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof changePlatformCustomersClearingConnector>>,
  TError,
  { platformUid: string; connectorType: ConnectorType },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof changePlatformCustomersClearingConnector>>,
    { platformUid: string; connectorType: ConnectorType }
  > = (props) => {
    const { platformUid, connectorType } = props ?? {};

    return changePlatformCustomersClearingConnector(platformUid, connectorType);
  };

  return { mutationFn, ...mutationOptions };
};

export type ChangePlatformCustomersClearingConnectorMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof changePlatformCustomersClearingConnector>>
  >;

export type ChangePlatformCustomersClearingConnectorMutationError = unknown;

export const useChangePlatformCustomersClearingConnector = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof changePlatformCustomersClearingConnector>>,
    TError,
    { platformUid: string; connectorType: ConnectorType },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof changePlatformCustomersClearingConnector>>,
  TError,
  { platformUid: string; connectorType: ConnectorType },
  TContext
> => {
  const mutationOptions =
    getChangePlatformCustomersClearingConnectorMutationOptions(options);

  return useMutation(mutationOptions);
};
export const migrateCashAccountPaymentDues = (platformUid: string) => {
  return customInstance<void>({
    url: `/operations/entity-internal-account/migrate/platforms/${platformUid}/customers/paymentDues`,
    method: 'PUT',
  });
};

export const getMigrateCashAccountPaymentDuesMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof migrateCashAccountPaymentDues>>,
    TError,
    { platformUid: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof migrateCashAccountPaymentDues>>,
  TError,
  { platformUid: string },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof migrateCashAccountPaymentDues>>,
    { platformUid: string }
  > = (props) => {
    const { platformUid } = props ?? {};

    return migrateCashAccountPaymentDues(platformUid);
  };

  return { mutationFn, ...mutationOptions };
};

export type MigrateCashAccountPaymentDuesMutationResult = NonNullable<
  Awaited<ReturnType<typeof migrateCashAccountPaymentDues>>
>;

export type MigrateCashAccountPaymentDuesMutationError = unknown;

export const useMigrateCashAccountPaymentDues = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof migrateCashAccountPaymentDues>>,
    TError,
    { platformUid: string },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof migrateCashAccountPaymentDues>>,
  TError,
  { platformUid: string },
  TContext
> => {
  const mutationOptions =
    getMigrateCashAccountPaymentDuesMutationOptions(options);

  return useMutation(mutationOptions);
};
export const transferCustomerVirtualAccountFundsForPlatform = (
  platformUid: string
) => {
  return customInstance<void>({
    url: `/operations/entity-internal-account/migrate/platforms/${platformUid}/customers/transferFunds`,
    method: 'POST',
  });
};

export const getTransferCustomerVirtualAccountFundsForPlatformMutationOptions =
  <TError = unknown, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof transferCustomerVirtualAccountFundsForPlatform>
      >,
      TError,
      { platformUid: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<ReturnType<typeof transferCustomerVirtualAccountFundsForPlatform>>,
    TError,
    { platformUid: string },
    TContext
  > => {
    const { mutation: mutationOptions } = options ?? {};

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof transferCustomerVirtualAccountFundsForPlatform>
      >,
      { platformUid: string }
    > = (props) => {
      const { platformUid } = props ?? {};

      return transferCustomerVirtualAccountFundsForPlatform(platformUid);
    };

    return { mutationFn, ...mutationOptions };
  };

export type TransferCustomerVirtualAccountFundsForPlatformMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof transferCustomerVirtualAccountFundsForPlatform>>
  >;

export type TransferCustomerVirtualAccountFundsForPlatformMutationError =
  unknown;

export const useTransferCustomerVirtualAccountFundsForPlatform = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof transferCustomerVirtualAccountFundsForPlatform>>,
    TError,
    { platformUid: string },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof transferCustomerVirtualAccountFundsForPlatform>>,
  TError,
  { platformUid: string },
  TContext
> => {
  const mutationOptions =
    getTransferCustomerVirtualAccountFundsForPlatformMutationOptions(options);

  return useMutation(mutationOptions);
};
export const recreateMissingCustomerVirtualAccountForPlatform = (
  platformUid: string,
  connectorType: ConnectorType
) => {
  return customInstance<void>({
    url: `/operations/entity-internal-account/migrate/platforms/${platformUid}/customers/${connectorType}`,
    method: 'PUT',
  });
};

export const getRecreateMissingCustomerVirtualAccountForPlatformMutationOptions =
  <TError = unknown, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof recreateMissingCustomerVirtualAccountForPlatform>
      >,
      TError,
      { platformUid: string; connectorType: ConnectorType },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof recreateMissingCustomerVirtualAccountForPlatform>
    >,
    TError,
    { platformUid: string; connectorType: ConnectorType },
    TContext
  > => {
    const { mutation: mutationOptions } = options ?? {};

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof recreateMissingCustomerVirtualAccountForPlatform>
      >,
      { platformUid: string; connectorType: ConnectorType }
    > = (props) => {
      const { platformUid, connectorType } = props ?? {};

      return recreateMissingCustomerVirtualAccountForPlatform(
        platformUid,
        connectorType
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type RecreateMissingCustomerVirtualAccountForPlatformMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof recreateMissingCustomerVirtualAccountForPlatform>>
  >;

export type RecreateMissingCustomerVirtualAccountForPlatformMutationError =
  unknown;

export const useRecreateMissingCustomerVirtualAccountForPlatform = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<typeof recreateMissingCustomerVirtualAccountForPlatform>
    >,
    TError,
    { platformUid: string; connectorType: ConnectorType },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof recreateMissingCustomerVirtualAccountForPlatform>>,
  TError,
  { platformUid: string; connectorType: ConnectorType },
  TContext
> => {
  const mutationOptions =
    getRecreateMissingCustomerVirtualAccountForPlatformMutationOptions(options);

  return useMutation(mutationOptions);
};
export const createCustomerVirtualAccountsForPlatform = (
  platformUid: string,
  connectorType: ConnectorType
) => {
  return customInstance<void>({
    url: `/operations/entity-internal-account/migrate/platforms/${platformUid}/customers/${connectorType}`,
    method: 'POST',
  });
};

export const getCreateCustomerVirtualAccountsForPlatformMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createCustomerVirtualAccountsForPlatform>>,
    TError,
    { platformUid: string; connectorType: ConnectorType },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createCustomerVirtualAccountsForPlatform>>,
  TError,
  { platformUid: string; connectorType: ConnectorType },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createCustomerVirtualAccountsForPlatform>>,
    { platformUid: string; connectorType: ConnectorType }
  > = (props) => {
    const { platformUid, connectorType } = props ?? {};

    return createCustomerVirtualAccountsForPlatform(platformUid, connectorType);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateCustomerVirtualAccountsForPlatformMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof createCustomerVirtualAccountsForPlatform>>
  >;

export type CreateCustomerVirtualAccountsForPlatformMutationError = unknown;

export const useCreateCustomerVirtualAccountsForPlatform = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createCustomerVirtualAccountsForPlatform>>,
    TError,
    { platformUid: string; connectorType: ConnectorType },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof createCustomerVirtualAccountsForPlatform>>,
  TError,
  { platformUid: string; connectorType: ConnectorType },
  TContext
> => {
  const mutationOptions =
    getCreateCustomerVirtualAccountsForPlatformMutationOptions(options);

  return useMutation(mutationOptions);
};
export const migratePlatformPaymentDues = (platformUid: string) => {
  return customInstance<void>({
    url: `/operations/entity-internal-account/migrate/platforms/${platformUid}/paymentDues`,
    method: 'PUT',
  });
};

export const getMigratePlatformPaymentDuesMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof migratePlatformPaymentDues>>,
    TError,
    { platformUid: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof migratePlatformPaymentDues>>,
  TError,
  { platformUid: string },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof migratePlatformPaymentDues>>,
    { platformUid: string }
  > = (props) => {
    const { platformUid } = props ?? {};

    return migratePlatformPaymentDues(platformUid);
  };

  return { mutationFn, ...mutationOptions };
};

export type MigratePlatformPaymentDuesMutationResult = NonNullable<
  Awaited<ReturnType<typeof migratePlatformPaymentDues>>
>;

export type MigratePlatformPaymentDuesMutationError = unknown;

export const useMigratePlatformPaymentDues = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof migratePlatformPaymentDues>>,
    TError,
    { platformUid: string },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof migratePlatformPaymentDues>>,
  TError,
  { platformUid: string },
  TContext
> => {
  const mutationOptions = getMigratePlatformPaymentDuesMutationOptions(options);

  return useMutation(mutationOptions);
};
export const transferPlatformVirtualAccountFunds = (platformUid: string) => {
  return customInstance<void>({
    url: `/operations/entity-internal-account/migrate/platforms/${platformUid}/transferFunds`,
    method: 'POST',
  });
};

export const getTransferPlatformVirtualAccountFundsMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof transferPlatformVirtualAccountFunds>>,
    TError,
    { platformUid: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof transferPlatformVirtualAccountFunds>>,
  TError,
  { platformUid: string },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof transferPlatformVirtualAccountFunds>>,
    { platformUid: string }
  > = (props) => {
    const { platformUid } = props ?? {};

    return transferPlatformVirtualAccountFunds(platformUid);
  };

  return { mutationFn, ...mutationOptions };
};

export type TransferPlatformVirtualAccountFundsMutationResult = NonNullable<
  Awaited<ReturnType<typeof transferPlatformVirtualAccountFunds>>
>;

export type TransferPlatformVirtualAccountFundsMutationError = unknown;

export const useTransferPlatformVirtualAccountFunds = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof transferPlatformVirtualAccountFunds>>,
    TError,
    { platformUid: string },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof transferPlatformVirtualAccountFunds>>,
  TError,
  { platformUid: string },
  TContext
> => {
  const mutationOptions =
    getTransferPlatformVirtualAccountFundsMutationOptions(options);

  return useMutation(mutationOptions);
};
export const createPlatformVirtualAccount = (
  platformUid: string,
  connectorType: ConnectorType
) => {
  return customInstance<void>({
    url: `/operations/entity-internal-account/migrate/platforms/${platformUid}/${connectorType}`,
    method: 'POST',
  });
};

export const getCreatePlatformVirtualAccountMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createPlatformVirtualAccount>>,
    TError,
    { platformUid: string; connectorType: ConnectorType },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createPlatformVirtualAccount>>,
  TError,
  { platformUid: string; connectorType: ConnectorType },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createPlatformVirtualAccount>>,
    { platformUid: string; connectorType: ConnectorType }
  > = (props) => {
    const { platformUid, connectorType } = props ?? {};

    return createPlatformVirtualAccount(platformUid, connectorType);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreatePlatformVirtualAccountMutationResult = NonNullable<
  Awaited<ReturnType<typeof createPlatformVirtualAccount>>
>;

export type CreatePlatformVirtualAccountMutationError = unknown;

export const useCreatePlatformVirtualAccount = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createPlatformVirtualAccount>>,
    TError,
    { platformUid: string; connectorType: ConnectorType },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof createPlatformVirtualAccount>>,
  TError,
  { platformUid: string; connectorType: ConnectorType },
  TContext
> => {
  const mutationOptions =
    getCreatePlatformVirtualAccountMutationOptions(options);

  return useMutation(mutationOptions);
};
